// TradeZakatTable.js
import React  from 'react';
function TradeZakatTable({ result}) {
  return (
    <table >
      <thead>
        <tr>
          <th >Status</th>
          <th > Hasil</th>
        </tr>
      </thead>
      <tbody>
        <tr >
          <td>Kewajiban zakat	</td>
          <td>{result.silverZakatDuty === 'yes' ? 'Zakat wajib atas Anda' : 'Zakat tidak wajib atas Anda'}</td>
        </tr>
        <tr >
          <td> Total Harta</td>
          <td>{result.moneyAmout}  </td>
        </tr>
        <tr >
          <td>Nisab zakat harta</td>
          <td>{result.threshold}  </td>
        </tr>
        <tr >
          <td>Jumlah zakat yang wajib dikeluarkan (dari uang)</td>
          <td>{result.tradeZakat}  </td>
        </tr>
      </tbody>
    </table>
  );
}
export default TradeZakatTable;